import { Chip } from '@mui/material';

type Props = {
  nomeArquivo?: string;
};

/**
 * Extensão do arquivo → semântica de `palette.statusChip`.
 * Mantém a convenção cromática de arquivo (PDF vermelho, planilha verde) dentro
 * das cinco semânticas do DESIGN.md: `.pdf` → `destructive`, `.xlsx` → `positive`.
 * Nenhuma das duas indica erro — aqui a cor só identifica a família do arquivo.
 */
export default function ChipExtensao({ nomeArquivo }: Props) {
  const extensao = nomeArquivo?.split('.').pop()?.toLowerCase();

  switch (extensao) {
    case 'pdf':
      return (
        <Chip
          label=".pdf"
          size="small"
          sx={(theme) => ({
            backgroundColor: theme.palette.statusChip.destructive.bg,
            color: theme.palette.statusChip.destructive.fg,
          })}
        />
      );
    case 'xlsx':
    case 'xls':
      return (
        <Chip
          label=".xlsx"
          size="small"
          sx={(theme) => ({
            backgroundColor: theme.palette.statusChip.positive.bg,
            color: theme.palette.statusChip.positive.fg,
          })}
        />
      );
    default:
      return <></>;
  }
}
